import { useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Divider,
  CircularProgress,
  useTheme,
  useMediaQuery,
  Box,
  Grid,
  ImageList,
  ImageListItem,
  IconButton,
  Paper,
} from "@mui/material";
import defaultImage from "../../images/default-image.png";
import { useEffect, useState } from "react";
// import ProdVideos from "../../../public/assets/Videos/ProdVideos.json"

const styles = {
  root: {
    width: "100%",
    display: 'flex',
    flexDirection: 'column',
    // minHeight: 750, // ksk-type
    height: 380, // pizzini-type
    // maxHeight:400,
    cursor: "pointer",
    border: "1px solid #9bcd65"
  },
  rootMobile: {
    width: "100%",
    display: 'flex',
    alignItems: "center",
    justifyContent: "center",
    flexDirection: 'column',
    // height: 600,
  },
  img: {
    height: 248,
    objectFit: "contain",
  },
  imgDetail: {
    objectFit: "contain",
    cursor: "pointer",
  },
  cardContent: {
    display: "flex",
    // alignItems: "center",
    justifyContent: "space-between",
  },
  price: {
    fontFamily: "Montserrat, sans-serif",
    fontOpticalSizing: "auto",
    fontWeight: 600,
    fontStyle: "normal",
    letterSpacing: "2.34px",
    lineHeight: "19px",
    color: "grey",
  },
  description: {
    fontFamily: "Montserrat, sans-serif ",
    fontOpticalSizing: "auto",
    fontWeight: 900,
    fontStyle: "normal",
    // lineHeight: "19px",
    fontSize: "16px",
  },
  zoomWindow: {
    position: 'absolute',
    top: 0,
    left: '100%',
    width: 450,
    height: 450,
    border: '1px solid #000',
    overflow: 'hidden',
    display: 'none',
    zIndex: 10,
    backgroundColor: '#fff',
  },
  zoomedImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '185%',
    height: '185%',
  },
};

const parseId = (id) => {
  return id.replace(/\//g, "-");
};


const VideosPrev = ({ rows }) => {
  return (
    <>
      {rows.length !== 0 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            position: "relative",
            justifyContent: "center",
            alignItems: "flex-end",
            gap: "5px",
            marginY: "10px"
          }}
        >
          <Typography
            sx={{
              ...styles.description,
              width: "100%",
              textAlign: "center",
              height: "20px",
            }}
          >
            Videos de ejemplos de uso
          </Typography>
          <Divider style={{ width: "100%" }} />

          {rows?.map((item, i) => (
            <Typography
              key={i} // Es importante agregar una key única aquí
              component={"a"}
              target="_blank"
              sx={{
                ...styles.description,
                textDecoration: "none",
                color: "black",
                fontSize: "13px",
                width: "100%",
                textAlign: "center",
                "&:hover": { textDecoration: "underline" },
              }}
              href={item.link}
            >
              {item.name}
            </Typography>
          ))}
        </Box>
      )}
    </>
  )
}



const ProductView = ({ productId, images }) => {
  const [mainContent, setMainContent] = useState({ type: "image", src: images[0] });
  const [errorImages, setErrorImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const theme = useTheme()

  const mobile = useMediaQuery(theme.breakpoints.down("sm"))
  const handleThumbnailClick = (item) => {
    setMainContent(item);
  };


  function parseYouTubeVideoId(url) {
    try {
      // Buscar la posición de "watch?v="
      const queryStringIndex = url.indexOf("watch?v=");
      if (queryStringIndex === -1) return null; // No es una URL válida de video

      // Extraer el ID del video
      const videoId = url.substring(queryStringIndex + 8).split("&")[0]; // Ignorar cualquier parámetro adicional
      return videoId || null;
    } catch (error) {
      console.error("Error parsing YouTube URL:", error);
      return null;
    }
  }

  const onError = (src, index) => {
    setErrorImages((prev) => [...prev, index]);
  };

  useEffect(() => {
    fetch("/assets/Videos/ProdVideos.json")
      .then((response) => {
        if (!response.ok) {
          console.error("Error al cargar el archivo JSON");
          return null;
        }
        return response.json();
      })
      .then((data) => {
        if (data && data[productId] && Array.isArray(data[productId])) {
          setVideos(data[productId]);
        } else {
          setVideos([]);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, [productId]);

  const resizeImage = errorImages.length === 0 || errorImages.length === 2 ? "100px" : "110px"
  const resizeListImage = errorImages.length === 0 || errorImages.length === 2 ? "400px" : "250px"

  return (
    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "15px" }}>
      <Box sx={{ display: 'flex', flexDirection: mobile ? 'column-reverse' : "row", position: 'relative', justifyContent: "center", gap: "5px" }}>
        {(mainContent.type === "image" && !mobile)
          &&
          <Box width={"150px"} />
        }
        <Box sx={{ width: mobile ? "350px" : resizeImage, overflowY: "auto", display: "flex" }}>
          <ImageList
            cols={1}
            sx={{
              display: "flex",
              flexDirection: mobile ? "row" : "column",
              height: mobile ? "90px" : resizeListImage,
            }}
          >
            {images.map((image, index) => {
              if (errorImages.includes(index)) return null;

              return (
                <ImageListItem key={index} onClick={() => handleThumbnailClick({ type: "image", src: image })}>
                  <Paper
                    elevation={3}
                    sx={{
                      border: "1px solid #9bcd65",
                      width: "85px", // Tamaño fijo para todas las miniaturas
                      height: "80px", // Tamaño fijo para todas las miniaturas
                    }}
                  >
                    <img
                      src={image}
                      onError={() => onError(image, index)} // Marcar la imagen con error
                      alt={`Thumbnail ${index}`}
                      style={{
                        cursor: "pointer",
                        width: "100%",
                        height: "100%",
                        objectFit: "cover", // Ajusta la imagen para llenar el espacio
                      }}
                    />
                  </Paper>
                </ImageListItem>
              );
            })}

            {videos.map((video, index) => (
              <ImageListItem key={`video-${index}`} onClick={() => handleThumbnailClick({ type: "video", src: video })}>
                <Paper
                  elevation={3}
                  sx={{
                    border: "1px solid #9bcd65",
                    width: "85px", // Tamaño fijo para todas las miniaturas
                    height: "80px", // Tamaño fijo para todas las miniaturas
                  }}
                >
                  <img
                    src={`https://img.youtube.com/vi/${parseYouTubeVideoId(video)}/hqdefault.jpg`}
                    alt={`Video Thumbnail ${index}`}
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      height: "100%",
                      objectFit: "cover", // Ajusta la miniatura para llenar el espacio
                    }}
                  />
                </Paper>
              </ImageListItem>
            ))}
          </ImageList>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Paper elevation={2} sx={{ border: "2px solid #9bcd65", height: mobile ? "300px" : "350px", width: mainContent.type === "image" ? "350px" : (mobile ? "350px" : "600px"), display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
            {mainContent.type === "image" ? (
              <img
                src={mainContent.src}
                alt="Main Product"
                onError={(e) => {
                  e.target.src = defaultImage;
                }}
                style={{
                  height: "100%", // Asegura que la imagen cubra todo el alto del Paper
                  width: "100%",  // Asegura que la imagen cubra todo el ancho del Paper
                  objectFit: "cover", // Ajusta la imagen para que no deje espacios en blanco
                }}
              />
            ) : (
              <iframe
                src={`https://www.youtube.com/embed/${parseYouTubeVideoId(mainContent.src)}`}
                title="Main Video"
                style={{
                  height: "100%", // Ocupa todo el alto del Paper
                  width: "100%",  // Ocupa todo el ancho del Paper
                  border: "none",
                }}
                allowFullScreen
              />
            )}
          </Paper>
        </Box>
      </Box >
    </Box>

  );
};


export default function ProductCardCatalogo({ product, index, productDetail = false, isClient = false }) {
  const randomQueryString = Math.random().toString(36).substring(7);
  const src = `${process.env.PUBLIC_URL}/assets/Catalogo/${parseId(product?.productId)}_1.jpg`; // ?${randomQueryString}
  const src2 = `${process.env.PUBLIC_URL}/assets/Catalogo/${parseId(product?.productId)}_2.jpg?${randomQueryString}`;
  const src3 = `${process.env.PUBLIC_URL}/assets/Catalogo/${parseId(product?.productId)}_3.jpg?${randomQueryString}`;
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const { pathname } = useLocation()
  const conditionalMobileCatalogo = pathname === "/"

  const description =
    product.productDescription.length > 70
      ? `${product.productDescription.substring(0, 70)}...`
      : product.productDescription;

  if (productDetail) {
    return <ProductView productId={product.productId} images={[src, src2, src3]} />
  }

  const isProducts = isClient ? `/product-details/${encodeURIComponent(product.productId)}` : `/catalogo-details/${encodeURIComponent(product.productId)}`

  return product.length === 0 ? (
    <CircularProgress />
  ) : (
    <Card elevation={3} style={mobile ? styles.rootMobile : styles.root} raised={true}>
      <CardMedia
        component="img"
        image={src}
        onError={(e) => {
          e.target.src = defaultImage;
        }}
        onClick={() => navigate(isProducts)}
        title={product.productDescription}
        sx={styles.img}
      />
      <CardContent>
        <Grid container style={styles.cardContent} spacing={2} >
          <Grid item sm={12} sx={mobile ? {
            width: conditionalMobileCatalogo ? "100%" : "90%", textAlign: "center", display: "flex",
            flexDirection: "column", justifyContent: "center", alignItems: "center"
          } : {}} >
            <Typography sx={{ ...styles.description, width: "100%", textAlign: "center", height: "60px" }}  >
              {description}
            </Typography>
            <Divider sx={{ width: mobile ? "100%" : "95%", textAlign: "center" }} />
          </Grid>
          {isClient &&
            <Grid item sm={12} display="flex" justifyContent="space-between" alignSelf={"flex-end"} sx={{ width: mobile ? "100%" : "92.5%" }}>
              <Typography sx={{ ...styles.price, marginRight: "15px" }}>
                <strong>Art. {product.productId}</strong>
              </Typography>
              <Typography sx={styles.price}>
                <strong>${product.unitPrice}</strong>
              </Typography>
            </Grid>
          }
        </Grid>
      </CardContent>
    </Card >
  );
}



